import React, { useState } from "react";
import DocumentMeta from "react-document-meta";

const CalculadoraDosificacion = () => {
    const [ppm, setPpm] = useState(1.5);
    const [Q, setQ] = useState(25); // m3/h
    const [C, setC] = useState(100); // g/l
    const [d, setD] = useState(1); // dilución
    const [caudalBomba, setCaudalBomba] = useState(6); // l/h
    const [resultadoQ, setResultadoQ] = useState(null);
    const [resultadoF, setResultadoF] = useState(null);
    const [cloroTanque, setCloroTanque] = useState(1); // litros
    const [aguaTanque, setAguaTanque] = useState(100); // litros
    const [diluir, setDiluir] = useState(true);

    const calcular = () => {
        let nuevoD = 1;
        if (diluir) {
            // Factor de dilución: (agua + cloro) / cloro
            nuevoD = cloroTanque / (aguaTanque + cloroTanque);
        }
        setD(nuevoD);

        // Fórmula q = (ppm * Q) / (C * d)
        let q = (ppm * Q) / (C * nuevoD);
        if(q > caudalBomba) {
            if(diluir){
                setResultadoF("DEBE AUMENTAR LA CONCENTRACIÓN DE CLORO ACTIVO O LA CANTIDAD DE CLORO EN EL TANQUE");
            } else {
                setResultadoF("DEBE AUMENTAR LA CONCENTRACIÓN DE CLORO ACTIVO");
            }
        } else {
            // Fórmula f = (q / caudalBomba) * 100
            const f = (q / caudalBomba) * 100;
            setResultadoF(f.toFixed(0));
        }
        setResultadoQ(q.toFixed(2));
    };

    return (
        <DocumentMeta
            title="Calculadora Dosificación de Cloro"
            description="Calculadora para dosificación de cloro en agua"
            canonical="https://ares.com.ar/calculadora-dosificacion"
            meta={{
                charset: 'utf-8',
                name: {
                    keywords: 'calculadora, dosificación, cloro, agua, hipoclorito, bomba'
                }
            }}
        >
            <div className="page-title-area ptb-100">
                <div className="container">
                    <div className="page-title-content">
                        <h1
                            style={{
                                fontSize: "2.2rem",
                                textAlign: "center",
                                marginBottom: "0.5em"
                            }}
                            className="calculadora-titulo"
                        >
                            Calculadora Dosificación de Cloro
                        </h1>
                    </div>
                </div>
                <div className="bg-image">
                    <img src={process.env.PUBLIC_URL + "/assets/img/banner/title.jpg"} alt="" />
                </div>
            </div>
            <div className="about-single-area ptb-100">
                <section className="about-section about-section-single">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="about-content">
                                    <h2>Ingrese los datos para calcular la dosificación</h2>
                                    <form
                                        onSubmit={e => {
                                            e.preventDefault();
                                            calcular();
                                        }}
                                        style={{
                                            maxWidth: 400,
                                            margin: "0 auto",
                                            padding: 24,
                                            borderRadius: 8,
                                            background: "#f9f9f9",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 16
                                        }}
                                    >
                                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                            <label style={{ fontWeight: 500 }}>ppm de cloro deseadas:</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                value={ppm}
                                                onChange={e => setPpm(Number(e.target.value))}
                                                style={{
                                                    padding: "8px",
                                                    borderRadius: 4,
                                                    border: "1px solid #ccc"
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                            <label style={{ fontWeight: 500 }}>Caudal de agua a tratar (m³/h):</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                value={Q}
                                                onChange={e => setQ(Number(e.target.value))}
                                                style={{
                                                    padding: "8px",
                                                    borderRadius: 4,
                                                    border: "1px solid #ccc"
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                            <label style={{ fontWeight: 500 }}>Concentración de cloro activo (g/l):</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                value={C}
                                                onChange={e => setC(Number(e.target.value))}
                                                style={{
                                                    padding: "8px",
                                                    borderRadius: 4,
                                                    border: "1px solid #ccc"
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <input
                                                type="checkbox"
                                                checked={diluir}
                                                onChange={e => setDiluir(e.target.checked)}
                                                id="diluir-checkbox"
                                            />
                                            <label htmlFor="diluir-checkbox" style={{ fontWeight: 500 }}>
                                                ¿Va a diluir el cloro en agua? *
                                            </label>
                                        </div>
                                        {diluir && (
                                            <>
                                                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                                    <label style={{ fontWeight: 500 }}>Cloro en el tanque (litros):</label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={cloroTanque}
                                                        onChange={e => setCloroTanque(Number(e.target.value))}
                                                        style={{
                                                            padding: "8px",
                                                            borderRadius: 4,
                                                            border: "1px solid #ccc"
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                                    <label style={{ fontWeight: 500 }}>Agua en el tanque (litros):</label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={aguaTanque}
                                                        onChange={e => setAguaTanque(Number(e.target.value))}
                                                        style={{
                                                            padding: "8px",
                                                            borderRadius: 4,
                                                            border: "1px solid #ccc"
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                            <label style={{ fontWeight: 500 }}>Caudal nominal de bomba (l/h):</label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                value={caudalBomba}
                                                onChange={e => setCaudalBomba(Number(e.target.value))}
                                                style={{
                                                    padding: "8px",
                                                    borderRadius: 4,
                                                    border: "1px solid #ccc"
                                                }}
                                            />
                                        </div>
                                        <button
                                            type="submit"
                                            style={{
                                                marginTop: 10,
                                                padding: "10px 0",
                                                background: "#007bff",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: 4,
                                                fontWeight: 600,
                                                cursor: "pointer"
                                            }}
                                        >
                                            Calcular
                                        </button>
                                    </form>
                                    
                                    <div style={{ marginTop: 20 }}>
                                        <strong style={{marginTop : 20}}>* Para diluir cloro activo con agua, debe utilizarse agua con bajo contenido de calcio y magnesio (agua blanda).</strong>
                                    </div>
                                    {resultadoQ !== null && (
                                        <div style={{ marginTop: 20 }}>
                                            <p><strong>Factor de dilución (d):</strong> {(1/d).toFixed(1)}</p>
                                            <p><strong>Caudal de dosificación (q):</strong> {resultadoQ} l/h</p>
                                            <p><strong>% de frecuencia de bomba (f):</strong> {(isFinite(resultadoF))? `${resultadoF}%`:`${resultadoF}`}</p>
                                        </div>
                                    )}
                                    <hr />
                                    
                                    <p>
                                        <strong>Fórmulas usadas:</strong><br />
                                        q = (ppm × Q) / (C × d)<br />
                                        f = (q / caudal bomba) × 100
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </DocumentMeta>
    );
};

export default CalculadoraDosificacion;